import * as actions from './loading.types';

export const setLoading = data => ({ type: actions.SET_LOADING, data });
